import React from "react";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import PayFailTab, {
  payFailTabState,
} from "../../components/pages/Pay/PayFail/PayFailTab";
import { useRecoilValue } from "recoil";
import CalculatePayFail from "../../components/pages/Pay/PayFail/CalculatePayFail";
import SimplePayFail from "../../components/pages/Pay/PayFail/SimplePayFail";

export default function PayFail() {
  const payFailTab = useRecoilValue(payFailTabState);

  return (
    <>
      <PageTitle title="결제 실패" />

      <PayFailTab />

      {payFailTab === 0 ? <CalculatePayFail /> : <SimplePayFail />}
    </>
  );
}
